import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

class StaffAddPhoto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.staff_id,
      photo: this.props.photo,
    };

    //bind específico
    this.addPhoto = this.addPhoto.bind(this);
    this.export = this.export.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.staff_certification_id !== 'undefined') {
      this.setState({
        id: newProps.staff_certification_id,
        photo: newProps.photo,
      });
    }
  }

  addPhoto(event) {
    event.preventDefault();
    var confirm = window.confirm('Tem certeza que gostaria de importar este arquivo? Ao importar, o arquivo anterior será substituído permanentemente.');
    if (confirm) {
      var data = new FormData();
      var imagedata = document.querySelector(".input-photo").files[0];
      data.append("id", this.state.id);
      data.append("imagem", imagedata);
      var header = this.refs.request_api.header();
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/colaborador/cadastrar/foto', { method: 'POST', mode: 'cors', headers: value, body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  export() {
    var self = this;
    var staff_id = this.state.id;
    var url = '/exportar/foto/colaborador/';
    var header = this.refs.request_api.header('application/json');
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/images/mecanicos/' + responseJson.data);
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h4>Foto</h4>
    <form onSubmit={self.addPhoto}>
        <div className="row">
            <div className="col-md-6 form-group">
                <input type="file" name="photo" className="form-control input-photo" placeholder="Arquivo" value={self.state.photo} onChange={self.handleChange.bind(self, 'photo')} />
            </div>
            <div className="col-md-3 form-group">
                <button type="submit" className={"btn btn-block btn-primary"}><i className="fa fa-save"> Salvar </i></button>
            </div>
            <div className="col-md-3 form-group">
                <button type="button" className={"btn btn-block btn-success"} onClick={self.export}><i className="fa fa-fw fa-file-o"> Abrir </i></button>
            </div>
        </div>
    </form>
</div>
    );
  }
}

export default StaffAddPhoto;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffAddPhoto.js